"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_multiscreen__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cf9f05d9-7cfd-4421-85ea-ebd03df6578c",
    "data-name": "Ebene 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4fd8e66-1772-4f84-9aff-ffa2b74880f0",
    x1: 35.84,
    y1: 26.34,
    x2: 156.16,
    y2: 146.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfaea3e3-8965-418b-b6a8-b2de790c5efe",
    x1: 102.91,
    y1: 71.36,
    x2: 173.19,
    y2: 141.64,
    xlinkHref: "#b4fd8e66-1772-4f84-9aff-ffa2b74880f0"
  })), /*#__PURE__*/React.createElement("title", null, "multiscreen-hi-dark"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 112,
    height: 160,
    rx: 8,
    ry: 8,
    transform: "translate(184 -8) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 152,
    height: 91,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 36,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 36,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 135,
    width: 12,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,142H24a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8v-2A8,8,0,0,1,168,142Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,42.5a1,1,0,0,1,1,1V130a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1V43.5a1,1,0,0,1,1-1H170m0-1H22a2,2,0,0,0-2,2V130a2,2,0,0,0,2,2H170a2,2,0,0,0,2-2V43.5a2,2,0,0,0-2-2Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 152,
    height: 91,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#b4fd8e66-1772-4f84-9aff-ffa2b74880f0)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,42a1,1,0,0,1,1,1v87a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1V43a1,1,0,0,1,1-1H170m0-1H22a2,2,0,0,0-2,2v87a2,2,0,0,0,2,2H170a2,2,0,0,0,2-2V43a2,2,0,0,0-2-2Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.05,
    y: 49,
    width: 59.9,
    height: 119,
    rx: 7.98,
    ry: 7.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 61,
    width: 51.9,
    height: 91,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 159.22,
    r: 4.45,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,166H116a8,8,0,0,1-7.95-8v2a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-2A8,8,0,0,1,160,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 55,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 55,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 61,
    width: 51.9,
    height: 91,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#bfaea3e3-8965-418b-b6a8-b2de790c5efe)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,62a1,1,0,0,1,1,1v87a1,1,0,0,1-1,1H114.1a1,1,0,0,1-1-1V63a1,1,0,0,1,1-1H162m0-1H114.1a2,2,0,0,0-2,2v87a2,2,0,0,0,2,2H162a2,2,0,0,0,2-2V63a2,2,0,0,0-2-2Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_multiscreen__dark;
exports.default = _default;